import {
  TARGET_TYPE,
  TARGET_TYPES_INTEGERS,
  STREAMING_OPTIONS
} from './Constants'

const convertViewingStreamForDisplay = (stream) => {
  const l = stream ? stream.toLowerCase() : '-'
  let rt = l
  switch (l) {
    case 'live':
      rt = 'Live'
      break
    case 'c3':
      rt = 'C3'
      break
    case 'c7':
      rt = 'C7'
      break
    case 'lsd':
      rt = 'LSD'
      break
    case 'l3':
      rt = 'L3'
      break
  }
  return rt
}

const convertViewingStreamForAM = (stream) => {
  const l = stream ? stream.toLowerCase() : stream
  let rt = l
  switch (l) {
    case 'aalive':
      rt = 'live'
      break
    case 'aalive3':
      rt = 'c3'
      break
    case 'aalive7':
      rt = 'c7'
      break
    case 'aalivesd':
      rt = 'lsd'
      break
  }
  return rt
}

const convertViewingStreamForES = (stream) => {
  const l = stream ? stream.toLowerCase() : 'lsd'
  let rt = l
  switch (l) {
    case 'live':
      rt = 'aalive'
      break
    case 'c3':
      rt = 'aalive3'
      break
    case 'c7':
      rt = 'aalive7'
      break
    case 'lsd':
      rt = 'aalivesd'
      break
  }
  return rt
}

const convertViewingStreamFullName = (stream) => {
  console.log(stream)
  for (const vs of STREAMING_OPTIONS) {
    if (vs.value === stream.toLowerCase()) {
      return vs.Name
    }
  }
  return null
}

// t = target
const convertTargetToTargetType = (t) => {
  if (t === TARGET_TYPE.LAS) {
    return TARGET_TYPES_INTEGERS.LAS
  } else if (t === TARGET_TYPE.AD) {
    return TARGET_TYPES_INTEGERS.AD
  } else if (t === TARGET_TYPE.SD) {
    return TARGET_TYPES_INTEGERS.SD
  } else if (t === TARGET_TYPE.ATT) {
    return TARGET_TYPES_INTEGERS.ATT
  } else if (t === TARGET_TYPE.NPOWER) {
    return TARGET_TYPES_INTEGERS.NPOWER
  } else if (t === TARGET_TYPE.COMSCORE) {
    return TARGET_TYPES_INTEGERS.COMSCORE
  } else if (t === TARGET_TYPE.PID) {
    return TARGET_TYPES_INTEGERS.PID
  } else if (t === TARGET_TYPE.COMSCORE_TV) {
    return TARGET_TYPES_INTEGERS.COMSCORE_TV
  }
}

export {
  convertViewingStreamForDisplay,
  convertViewingStreamForAM,
  convertViewingStreamForES,
  convertViewingStreamFullName,
  convertTargetToTargetType
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/conversions.js